import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './LosingClients.css';

const LosingClients = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const statsRef = useRef(null);
  
  // Animation on scroll
  useEffect(() => {
    const section = sectionRef.current;
    const title = titleRef.current;
    const description = descriptionRef.current;
    const stats = statsRef.current;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('visible');
          setTimeout(() => title.classList.add('visible'), 200);
          setTimeout(() => description.classList.add('visible'), 500);
          setTimeout(() => stats.classList.add('visible'), 800);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    if (section) {
      observer.observe(section);
    }
    
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="losing-clients" ref={sectionRef}>
      <div className="container">
        <div className="losing-clients-content">
          <div className="losing-clients-text">
            <h2 className="losing-clients-title" ref={titleRef}>
              <span className="title-highlight">{t('losingClientsTitle')}</span>
            </h2>
            
            <p className="losing-clients-description" ref={descriptionRef}>
              {t('losingClientsDescription')}
            </p>
          </div>
          
          <div className="losing-clients-stats" ref={statsRef}>
            <div className="stat-card">
              <div className="stat-value">{t('losingClientsStat1')}</div>
              <div className="stat-divider"></div>
              <div className="stat-description">{t('losingClientsStat1Desc')}</div>
              <div className="stat-source">{t('losingClientsStat1Source')}</div>
            </div>
            
            <div className="stat-card">
              <div className="stat-value">{t('losingClientsStat2')}</div>
              <div className="stat-divider"></div>
              <div className="stat-description">{t('losingClientsStat2Desc')}</div>
              <div className="stat-source">{t('losingClientsStat2Source')}</div>
            </div>
            
            <div className="stat-card">
              <div className="stat-value">{t('losingClientsStat3')}</div>
              <div className="stat-divider"></div>
              <div className="stat-description">{t('losingClientsStat3Desc')}</div>
              <div className="stat-source">{t('losingClientsStat3Source')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LosingClients;
